import { graphql } from 'gql.tada';
import { useQuery } from '@apollo/client';

const EnrollmentPacketForAdminQuery = graphql.persisted(
  "EnrollmentPacketForAdmin",
  graphql(`
    query EnrollmentPacketForAdmin($familyEnrollmentId: String!) {
      enrollmentPacketForAdmin(familyEnrollmentId: $familyEnrollmentId) {
        formState
        familyName
        schoolName
        schoolYearName
        signedAt
        signedBy
        signedIpAddress
        formAnswers
        students
        invoiceSummary
        invoicesChangedSinceSigning
        policyDocuments
        paymentSettings
        paymentOptionName
      }
    }
  `)
);

export { EnrollmentPacketForAdminQuery };

export function useEnrollmentPacketForAdmin(familyEnrollmentId: string | undefined) {
  return useQuery(EnrollmentPacketForAdminQuery, {
    variables: { familyEnrollmentId: familyEnrollmentId! },
    skip: !familyEnrollmentId,
  });
}
